'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { identifyAtlasUser, waitForAtlasStarted } from '@/hooks/use-atlas-chat';
import { useAuth } from '@/providers/auth-provider';
export function AtlasProvider() {
  const $ = _c(5);
  const {
    user,
    isAuthenticated
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  let t1;
  let t2;
  if ($[1] !== isAuthenticated || $[2] !== user) {
    t1 = () => {
      if (!isAuthenticated || !user) {
        return;
      }
      identifyAtlasUser({
        cacheKey: `${user.id}:${user.updated_at ?? ""}`
      });
    };
    t2 = [isAuthenticated, user];
    $[1] = isAuthenticated;
    $[2] = user;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return null;
}
function _temp2() {
  let isCancelled = false;
  waitForAtlasStarted().then(() => {
    if (!isCancelled) {
      window.Atlas.chat?.hideBubble();
    }
  }).catch(_temp);
  return () => {
    isCancelled = true;
  };
}
function _temp() {}